import PointerProps from './PointerProps'

let KendoRadialGaugePointer = {
    name: 'kendo-radialgauge-pointer',
    render () {
        return null
    },
    mixins: [PointerProps]
}

export default KendoRadialGaugePointer


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoRadialGauge/KendoRadialGaugePointer.js